"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Utils = __importStar(require("./utils/utils"));
/**
 * Generate an action route
 * @param prefixUrl Prefix of the API
 * @param action Name of the action
 * @return The route
 */
function action(prefixUrl, action) {
    return prefixUrl + "/a/actions/" + action;
}
exports.action = action;
/**
 * Generate a create route
 * @param prefixUrl Prefix of the API
 * @param entity Name of the entity
 * @return The route
 */
function create(prefixUrl, entity) {
    return prefixUrl + "/" + entity;
}
exports.create = create;
/**
 * Generate a create route (for multiple items)
 * @param prefixUrl Prefix of the API
 * @param entity Name of the entity
 * @return The route
 */
function createMany(prefixUrl, entity) {
    return prefixUrl + "/" + Utils.pluralize(entity);
}
exports.createMany = createMany;
/**
 * Generate a fetch route
 * @param prefixUrl Prefix of the API
 * @param entity Name of the entity
 * @param id The entity id
 * @return The route
 */
function get(prefixUrl, entity, id) {
    return prefixUrl + "/" + entity + "/" + id;
}
exports.get = get;
/**
 * Generate a fetch route (for multiple items)
 * @param prefixUrl Prefix of the API
 * @param entity Name of the entity
 * @param id The entity id
 * @return The route
 */
function getMany(prefixUrl, entity) {
    return prefixUrl + "/" + Utils.pluralize(entity) + "/read";
}
exports.getMany = getMany;
/**
 * Generate an update route
 * @param prefixUrl Prefix of the API
 * @param entity Name of the entity
 * @param id The entity id
 * @param usePost Instead of using PUT, we use POST, so the URL is a bit different
 * @return The route
 */
function update(prefixUrl, entity, id, usePost) {
    if (usePost === void 0) { usePost = false; }
    if (usePost) {
        return prefixUrl + "/" + entity + "/update/" + id;
    }
    return prefixUrl + "/" + entity + "/" + id;
}
exports.update = update;
/**
 * Generate a delete route
 * @param prefixUrl Prefix of the API
 * @param entity Name of the entity
 * @param id The entity id
 * @param useGet Instead of using DELETE, we use GET, so the URL is a bit different
 * @return The route
 */
function del(prefixUrl, entity, id, useGet) {
    if (useGet === void 0) { useGet = false; }
    if (useGet) {
        return prefixUrl + "/" + entity + "/delete/" + id;
    }
    return prefixUrl + "/" + entity + "/" + id;
}
exports.del = del;
/**
 * Generate a custom route
 * @param prefixUrl Prefix of the API
 * @param endpoint The endpoint
 * @return The route
 */
// export function custom(prefixUrl: string, endpoint: string) {
//    return `${prefixUrl}/${endpoint}`;
// }
/**
 * Generate a validation route
 * @param prefixUrl Prefix of the API
 * @param entity Name of the entity
 * @param pipers The name of the pipers to use
 * @return The route
 */
function validation(prefixUrl, entity, pipers) {
    return prefixUrl + "/" + entity + "/validation/" + pipers.join(',');
}
exports.validation = validation;
/**
 * Generate a validation route (for multiple items)
 * @param prefixUrl Prefix of the API
 * @param entity Name of the entity
 * @param pipers The name of the pipers to use
 * @return The route
 */
function validationMany(prefixUrl, entity, pipers) {
    return prefixUrl + "/" + Utils.pluralize(entity) + "/validation/" + pipers.join(',');
}
exports.validationMany = validationMany;
//# sourceMappingURL=routes.js.map